import { fetchCategories } from '../../api/api'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

type Category = {
  history: string
  _id: string
  cateName: string
  createdAt: string
  updatedAt: string
  __v: number
}

type CategoryState = {
  success: boolean
  allCates: Category[]
}
export const fetchAllCategories = createAsyncThunk(
  'categories/fetchAllCategories',
  async () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response = fetchCategories()
    return ((await response).data)
  }
)

const initialState: CategoryState = {
  success: false,
  allCates: [],
}

export const categoriesSlices = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    // getAllProducts: async () => {
    //   const data = await fetchProducts()
    // },

  },
  extraReducers: (builders) => {
    builders.addCase(fetchAllCategories.fulfilled, (state, action) => {
      state.allCates = action.payload.categories
      state.success = action.payload.success
    })
  }
})

export const all = categoriesSlices.actions

export default categoriesSlices.reducer
